/*!
 * 1DS JS SDK Properties plugin, 2.4.7
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* TelemetryContext.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
var AppExtensionKeys = /** @class */ (function () {
    function AppExtensionKeys() {
    }
    AppExtensionKeys.id = 'id';
    AppExtensionKeys.ver = 'ver';
    AppExtensionKeys.appName = 'name';
    AppExtensionKeys.locale = 'locale';
    AppExtensionKeys.expId = 'expId';
    AppExtensionKeys.env = 'env';
    return AppExtensionKeys;
}());
export { AppExtensionKeys };
var WebExtensionKeys = /** @class */ (function () {
    function WebExtensionKeys() {
    }
    WebExtensionKeys.domain = 'domain';
    WebExtensionKeys.browser = 'browser';
    WebExtensionKeys.browserVer = 'browserVer';
    WebExtensionKeys.screenRes = 'screenRes';
    WebExtensionKeys.userConsent = 'userConsent';
    WebExtensionKeys.consentDetails = 'consentDetails';
    return WebExtensionKeys;
}());
export { WebExtensionKeys };
var UserExtensionKeys = /** @class */ (function () {
    function UserExtensionKeys() {
    }
    UserExtensionKeys.locale = 'locale';
    UserExtensionKeys.localId = 'localId';
    UserExtensionKeys.id = 'id';
    return UserExtensionKeys;
}());
export { UserExtensionKeys };
var OSExtKeys = /** @class */ (function () {
    function OSExtKeys() {
    }
    OSExtKeys.osName = 'name';
    OSExtKeys.ver = 'ver';
    return OSExtKeys;
}());
export { OSExtKeys };
var SDKExtKeys = /** @class */ (function () {
    function SDKExtKeys() {
    }
    SDKExtKeys.ver = 'ver';
    SDKExtKeys.seq = 'seq';
    SDKExtKeys.installId = 'installId';
    SDKExtKeys.epoch = 'epoch';
    return SDKExtKeys;
}());
export { SDKExtKeys };
var IntWebExtKeys = /** @class */ (function () {
    function IntWebExtKeys() {
    }
    IntWebExtKeys.msfpc = 'msfpc';
    IntWebExtKeys.anid = 'anid';
    IntWebExtKeys.serviceName = 'serviceName';
    return IntWebExtKeys;
}());
export { IntWebExtKeys };
var UtcExtKeys = /** @class */ (function () {
    function UtcExtKeys() {
    }
    UtcExtKeys.popSample = 'popSample';
    UtcExtKeys.eventFlags = 'eventFlags';
    return UtcExtKeys;
}());
export { UtcExtKeys };
var LocExtKeys = /** @class */ (function () {
    function LocExtKeys() {
    }
    LocExtKeys.tz = 'tz';
    return LocExtKeys;
}());
export { LocExtKeys };
var SessionExtKeys = /** @class */ (function () {
    function SessionExtKeys() {
    }
    SessionExtKeys.sessionId = 'sesId';
    return SessionExtKeys;
}());
export { SessionExtKeys };
var DeviceExtKeys = /** @class */ (function () {
    function DeviceExtKeys() {
    }
    DeviceExtKeys.localId = 'localId';
    DeviceExtKeys.deviceClass = 'deviceClass';
    DeviceExtKeys.make = 'make';
    DeviceExtKeys.model = 'model';
    return DeviceExtKeys;
}());
export { DeviceExtKeys };
var CloudExtKeys = /** @class */ (function () {
    function CloudExtKeys() {
    }
    CloudExtKeys.role = 'role';
    CloudExtKeys.roleInstance = 'roleInstance';
    CloudExtKeys.roleVer = 'roleVer';
    return CloudExtKeys;
}());
export { CloudExtKeys };
var TraceExtKeys = /** @class */ (function () {
    function TraceExtKeys() {
    }
    TraceExtKeys.traceId = 'traceID';
    TraceExtKeys.traceName = 'name';
    TraceExtKeys.parentId = 'parentID';
    return TraceExtKeys;
}());
export { TraceExtKeys };
//# sourceMappingURL=ExtensionKeys.js.map